import { Observable } from "rxjs";

export class Queue<T> {
    public items: T[] = [];
    private maxSize: number;
    constructor(maxSize: number) {
      if (maxSize <= 0) {
        throw new Error("maxSize debe ser mayor que 0.");
      }
      this.maxSize = maxSize;
    }
  
    // Agrega un elemento al final y elimina el primero si se excede el tamaño
    push(item: T): void {
      if (this.items.length >= this.maxSize) {
        this.items.shift(); // Elimina el más antiguo
      }
      this.items.push(item);
    }
  
    // Elimina y retorna el primer elemento
    shift(): T | undefined {
      return this.items.shift();
    }
  
    // Retorna el primer elemento sin eliminarlo
    peek(): T | undefined {
      return this.items[0];
    }

    // Retorna el primer elemento sin eliminarlo
    last(): T | undefined {
        if (this.size() === 0) {
            return;
        }
        return this.items[this.size() - 1];
      }
  
    // Retorna el número de elementos en la cola
    size(): number {
      return this.items.length;
    }
  
    // Verifica si la cola está vacía
    isEmpty(): boolean {
      return this.items.length === 0;
    }
  
    // Limpia la cola
    clear(): void {
      this.items = [];
    }
  }